import React, { useContext } from 'react'

import { Button } from '@clientbase/clientbase-library'
import { useMediaQuery } from '@mui/material'

import { NegativationContext } from '../../../context'

interface ContactProps {
  hiddenButton?: boolean
}

const Contact: React.FC<ContactProps> = () => {
  const { updateDialogContact, negativation, updateModalDetail } =
    useContext(NegativationContext)

  const isMobile = useMediaQuery('(max-width:600px)')

  const openDialog = () => {
    updateModalDetail((prevState) => ({
      ...prevState,
      open: false
    }))
    updateDialogContact({
      open: true,
      email: negativation?.customer?.email,
      name: negativation?.customer?.name,
      phone: negativation?.customer?.phone
    })
  }

  return (
    <Button onClick={openDialog} fullWidth={isMobile}>
      Entrar em contato
    </Button>
  )
}

export default Contact
